import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppProvider } from './context/AppContext';

class Main extends Component {
  setShowBurgerMenu = showBurgerMenu => this.setState({ showBurgerMenu });

  state = {
    showBurgerMenu: false,
    setShowBurgerMenu: this.setShowBurgerMenu,
  };

  render() {
    return <AppProvider value={this.state}>{this.props.children}</AppProvider>;
  }
}

Main.propTypes = { children: PropTypes.node };

export default Main;
